module.exports = __webpack_public_path__ + "static/media/trello.1ce6bc2d.svg";